import { useState } from "react";
import { Input } from "reactstrap";
import cx from "classnames";
import FiltersOptions from "../../components/FiltersOptions/FiltersOptions";
import FiltersButtons from "../../components/FiltersButtons/FiltersButtons";
import PropTypes from "prop-types";
import styles from "./Filter.module.scss";

const Filter = ({
  t,
  name,
  onSave,
  selected,
  onChange,
  onClear,
  btnEnterName,
  options = [],
  isMultiple,
}) => {
  const [searchInput, setSearchInput] = useState("");

  const sortOptions = (options) => {
    const isAllOption = (option) =>
      option?.value === "all" ||
      option?.label === "all" ||
      option?.label === "все";
    const filteredBySearch = searchInput
      ? options.filter((option) =>
          option?.label?.toLowerCase().includes(searchInput)
        )
      : [...options];

    return filteredBySearch.sort((a, b) => {
      const aAll = isAllOption(a);
      const bAll = isAllOption(b);
      if (aAll && !bAll) return -1;
      if (!aAll && bAll) return 1;
      return (a.label || "").localeCompare(b.label || "", undefined, {
        sensitivity: "base",
      });
    });
  };

  return (
    <div className={styles.filterContainer}>
      <div className={styles.inputContainer}>
        <Input
          className={styles.searchInput}
          onChange={(e) => {
            setSearchInput(e.target.value.toLowerCase());
          }}
          value={searchInput}
          placeholder="Search here"
        />
      </div>

      <div className={styles.fitersListPanel}>
        <div className={cx(styles.filtersGroup)}>
          {name && (
            <FiltersOptions
              options={sortOptions([...options])}
              onChange={onChange}
              selected={selected}
              name={name}
              isMultiple={isMultiple}
            />
          )}
        </div>
        <FiltersButtons
          onClear={onClear}
          onSave={onSave}
          btnEnterName={btnEnterName}
          setSearchInput={setSearchInput}
          className={styles.filtersButtons}
        />
      </div>
    </div>
  );
};

Filter.propTypes = {
  option: PropTypes.array,
  name: PropTypes.string,
  onChange: PropTypes.func,
  isSearchInput: PropTypes.bool,
  onClear: PropTypes.func,
  selected: PropTypes.array,
};

export default Filter;
